import {
    useEffect,
    useState,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';

import { useParams } from "react-router-dom";

import ReactSelect from 'react-select';

import { Search as SearchIcon } from 'react-feather';

import { Simdata5gAction } from 'src/actions/simdata5g.action';

import numeral from 'numeral';

import { Helmet } from "react-helmet";

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
} from 'src/utils/constants';

import iconMobifone from "../../assets/images/icon_mobifone.png";
import iconVinaphone from "../../assets/images/icon_vinaphone.png";
import iconViettel from "../../assets/images/icon_viettel.png";
import logoNhaMang from "../../assets/images/logo_mang.svg";
import { LocationAction } from 'src/actions/location.action';

const TheHomepageSimdata5gOne = ({ product }) => {
    const dispatch = useDispatch()
    const { itemId } = useParams();
    const { homepageSimdata5gSelected } = useSelector(state => state.simdata5g)
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [name, setName] = useState("");
    const [image, setImage] = useState("");
    const [price, setPrice] = useState("");
    const [price_new, setPriceNew] = useState("");
    const [operator, setOperator] = useState("");
    const [operator1, setOperator1] = useState("");
    const [time_by_month, setTimeByMonth] = useState("");
    const [description, setDescription] = useState("");
    const [tinh_trang, setTinhTrang] = useState("");
    const [tinh_trang_color, setTinhTrangColor] = useState("");
    const { isLoading } = useSelector(state => state.app);

    const danhSachLoaiSim = SIM_TYPE_LIST_OBJ;

    useEffect(() => {
        console.log(itemId);
        dispatch(Simdata5gAction.homepageFindOne(itemId));
    }, [])

    useEffect(() => {
        console.log(homepageSimdata5gSelected);

        setName('');
        setImage('');
        setPrice('');
        setPriceNew('');
        setOperator('');
        setTimeByMonth('');
        setDescription('');
        setTinhTrang('');
        setTinhTrangColor('');

        if (homepageSimdata5gSelected) {
            setName(homepageSimdata5gSelected.name ? homepageSimdata5gSelected.name : '');
            setImage(homepageSimdata5gSelected.image ? homepageSimdata5gSelected.image : '');
            setPrice(homepageSimdata5gSelected.price ? Number(homepageSimdata5gSelected.price) : '0');
            setPriceNew(homepageSimdata5gSelected.price_new ? Number(homepageSimdata5gSelected.price_new) : '0');
            setOperator(homepageSimdata5gSelected.operator)
            setOperator1(homepageSimdata5gSelected.operator == "MOBIFONE" ? "-160px 3px" : (homepageSimdata5gSelected.operator == "VINAPHONE" ? "-80px 3px" : "0px 3px"))
            setTimeByMonth(homepageSimdata5gSelected.time_by_month ? numeral(homepageSimdata5gSelected.time_by_month).format('0,0') + ' tháng' : '0 tháng');
            setDescription(homepageSimdata5gSelected.description ? homepageSimdata5gSelected.description : '');

            setTinhTrang(homepageSimdata5gSelected.trang_thai == 'con_sim' ? 'Còn hàng' : (homepageSimdata5gSelected.trang_thai == 'giu_so' ? '' : 'Hết hàng'))
            setTinhTrangColor(homepageSimdata5gSelected.trang_thai == 'con_sim' ? 'green' : (homepageSimdata5gSelected.trang_thai == 'giu_so' ? 'orange' : 'red'))

            async function fetchData() {
                try {
                    let getProvinces = await dispatch(LocationAction.getProvinces());
                    console.log(getProvinces);
                    setProvinces(getProvinces);
                } catch (error) {
                    console.error(error);
                }
            }

            fetchData();
        }
    }, [homepageSimdata5gSelected])

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        province: "-99",
        province_name: "",
        district: "-99",
        district_name: "",
        ward: "-99",
        ward_name: "",
        address: "",
        note: "",
        paymentMethod: "cod",
        quantity: 1,
        itemId,
    });

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    ward: "-99", 
                    ward_name: "", 
                });
                setWards([]);
                let getWards = await dispatch(LocationAction.getWardsByDistrict(formData.district));
                console.log(getWards);
                setWards(getWards);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province, formData.district])

    useEffect(() => {
        async function fetchData() {
            try {
                setFormData({ 
                    ...formData, 
                    district: "-99",
                    district_name: "", 
                });
                setDistricts([]);
                let getDistricts = await dispatch(LocationAction.getDistrictsByProvince(formData.province));
                console.log(getDistricts);
                setDistricts(getDistricts);
            } catch (error) {
                console.error(error);
            }
        }

        fetchData();
    }, [formData.province])

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleChange1 = (key, value, key1 = null, value1 = null) => {
        if (key1 && value1) {
            setFormData({ 
                ...formData, 
                [key]: value,
                [key1]: value1,
            });
        } else {
            setFormData({ 
                ...formData, 
                [key]: value 
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(Simdata5gAction.sendOrder(formData));
    };

    return (<>
        <Helmet>
            <title>{name} | Kho số - Di Dong Telecom</title>
        </Helmet>

        {isLoading && <div className='loading'></div>}

        {!isLoading && <div style={{ margin: "0 0", padding: "20px", borderRadius: "10px", boxShadow: "0px 4px 10px rgba(0,0,0,0.2)", background: "var(--background-color)" }}>
            {name && <>
                <div style={{color: '#037319', fontSize: '26px', fontWeight: 'bold', padding: "0"}}>{name}</div>
                <div className='simdata5g-one-detail-container' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "20px 0 20px 0", background: "transparent", borderRadius: "10px" }}>
                    {image?.match(/\.(mp4|webm|ogg)$/i) ? (
                        <video className='simdata5g-one-img' src={image} controls style={{ gap: "10px", width: "50%" }} />
                    ) : (
                        <img className='simdata5g-one-img' src={image} alt={name} style={{gap: "10px", width: "50%"}}/>
                    )}
                    <div className='simdata5g-one-detail' style={{ display: "grid", gridTemplateColumns: "100px auto", gap: "10px", width: "50%", padding: "0 0 0 20px", alignItems: 'center' }}>
                        <strong>Giá:</strong> <span className='price' style={{color: 'var(--main-color)', fontWeight: 'bold'}}>
                            {
                                price_new > 0 && price_new < price ? (
                                    <div>
                                        <span style={{ color: "red", fontWeight: "bold" }}>{numeral(price_new).format("0,0")}₫</span>
                                        <br></br>
                                        <span className='price-old' style={{ textDecoration: "line-through", color: "#888" }}>{numeral(price).format("0,0")}₫</span>
                                    </div>
                                ) : (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>{numeral(price).format("0,0")}₫</span>
                                    </div>
                                )
                            }
                        </span>
                        <strong>Nhà mạng:</strong> 
                        <span style={{
                            backgroundImage: `url(${logoNhaMang})`,
                            backgroundPosition: operator1,
                            backgroundSize: "cover",
                            display: "inline-block",
                            width: 80,
                            height: 35
                        }}></span>
                        <strong>Thời hạn:</strong> <span>{time_by_month}</span>
                        <strong>Tình trạng:</strong> <span style={{ color: tinh_trang_color }}>{tinh_trang}</span>
                    </div>
                </div>
                <div className='simdata5g-content media-content' style={{padding: "0 0 20px 0"}} dangerouslySetInnerHTML={{ __html: description }} />
            </>}
            
            {name && homepageSimdata5gSelected && homepageSimdata5gSelected.trang_thai == 'con_sim' && <>
                <div style={{color: '#FF0000', fontSize: '24px', fontWeight: 'bold', padding: "0 0 20px 0"}}>THÔNG TIN ĐẶT HÀNG</div>
                <form className='form-dat-hang' onSubmit={handleSubmit} style={{ display: "grid", gap: "15px", padding: "0" }}>
                    <div>
                        <label>Số lượng <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="quantity" value={formData.quantity} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Họ và tên <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="name" value={formData.name} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Số điện thoại <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="phone" value={formData.phone} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    {/* <div>
                        <label>Email <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div> */}
                    <div>
                        <label>Tỉnh/thành:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn tỉnh/thành' },
                                    ...provinces
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.province_name || "Chọn tỉnh/thành..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.province || null}
                                onChange={(newValue) => {
                                    handleChange1('province', newValue.code, 'province_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Quận/huyện:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn quận/huyện' },
                                    ...districts
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.district_name || "Chọn quận/huyện..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.district || null}
                                onChange={(newValue) => {
                                    handleChange1('district', newValue.code, 'district_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Phường/xã:</label>
                        <div style={{ width: '100%', zIndex: '10', marginTop: 0 }} className="full-width-select">
                            <ReactSelect
                                classNamePrefix="nt-select"
                                menuPortalTarget={document.body}
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 999999,
                                    }),
                                    control: (provided) => ({
                                        ...provided,
                                        height: 37,
                                    }),
                                    option: (provided) => ({
                                        ...provided,
                                    }),
                                }}
                                options={[
                                    { code: '-99', name: 'Chọn phường/xã' },
                                    ...wards
                                ]}
                                getOptionLabel={(item) => `${item.name}`}
                                placeholder={formData.ward_name || "Chọn phường/xã..."}
                                components={{
                                    DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                    IndicatorSeparator: null,
                                }}
                                value={formData.ward || null}
                                onChange={(newValue) => {
                                    handleChange1('ward', newValue.code, 'ward_name', newValue.name);
                                }}
                                isSearchable
                            />
                        </div>
                    </div>
                    <div>
                        <label>Địa chỉ chi tiết <span style={{color: 'var(--main-color)'}}>*</span>:</label>
                        <input type="text" name="address" value={formData.address} onChange={handleChange} required style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <label>Ghi chú (nếu có):</label>
                        <input type="text" name="note" value={formData.note} onChange={handleChange} style={{ width: "100%", padding: "10px", border: "1px solid #ddd", borderRadius: "5px" }} />
                    </div>
                    <div>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <label>
                                <input type="radio" name="paymentMethod" value="cod" checked={formData.paymentMethod === "cod"} onChange={handleChange} /> COD
                            </label>
                            <label>
                                <input type="radio" name="paymentMethod" value="online" checked={formData.paymentMethod === "online"} onChange={handleChange} /> Chuyển khoản
                            </label>
                        </div>
                    </div>
                    <button type="submit" style={{ marginTop: "10px", padding: "10px", background: "var(--main-color)", color: "#fff", border: "none", borderRadius: "5px", cursor: "pointer", fontSize: "16px", fontWeight: "bold", transition: "0.3s" }}
                        onMouseEnter={(e) => e.target.style.background = "var(--main-color)"}
                        onMouseLeave={(e) => e.target.style.background = "var(--main-color)"}>
                        Đặt hàng
                    </button>
                </form>
            </>}
        </div>}
    </>);
};

export default TheHomepageSimdata5gOne;